import React from 'react';
import type { FC, ReactNode } from 'react';
import { IconClose, TrashBinIcon } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import { Modal, modalStyles } from '../../ui/ModalProject';
import { Button } from '../../ui/Button/Button';
import styles from './DeleteConfirmModal.module.scss';

export interface DeleteConfirmModalProps {
    open: boolean;
    title: string;
    name?: string;
    items: string[];
    warnTitle?: string;
    warnText?: ReactNode;
    busy?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
    open,
    title,
    name,
    items,
    warnTitle = 'Действие нельзя отменить.',
    warnText,
    busy = false,
    onCancel,
    onConfirm,
}) => (
    <Modal open={open} onClose={onCancel} ariaLabel={title} style={{ width: 420 }}>
        <div className={modalStyles.head}>
            <div className={cx(modalStyles.icon, modalStyles.iconDanger)}>
                <TrashBinIcon />
            </div>

            <div>
                <h3>{title}</h3>

                {name && <p className={styles.name}>{name}</p>}

                <p className={styles.block}>После удаления:</p>
                {items.map((item) => (
                    <p key={item} className={styles.item}>
                        {item}
                    </p>
                ))}

                <p className={styles.block}>
                    <b className={styles.strong}>{warnTitle}</b>
                    {warnText && <> {warnText}</>}
                </p>
            </div>

            <button
                type="button"
                className={modalStyles.close}
                aria-label="Закрыть"
                onClick={onCancel}
            >
                <IconClose />
            </button>
        </div>

        <div className={modalStyles.foot}>
            <div className={modalStyles.footRight}>
                <Button onClick={onCancel} disabled={busy}>
                    Отмена
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={busy}>
                    {busy ? 'Удаляем…' : 'Удалить'}
                </Button>
            </div>
        </div>
    </Modal>
);